<template>
  <div class="zj-layout-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZjLayoutFooter'
}
</script>
